const CDN_FONT_BASE = 'https://cdn1.ourmailsender.com/fonts'
const WEIGHT_FILE_SUFFIX = {
    400: 'Regular',
    700: 'Bold'
}

function fontFileBase(font) {
    const name = String((font && font.label) || '').replace(/ /g, '')
    return {
        name,
        folder: name.toLowerCase()
    }
}

function faceRule(family, url, extras) {
    const lines = [
        '@font-face {',
        `    font-family: ${family};`,
        `    src: url(${url});`
    ]
    if (extras) {
        lines.push(`    font-weight: ${extras.weight};`)
        lines.push(`    font-style: ${extras.style || 'normal'};`)
    }
    lines.push('}')
    return lines.join('\n')
}

/**
 * Build @font-face CSS for a catalog font.
 * Families without `weights` keep the existing Regular-only rule (no font-weight).
 * Families with `weights: [400, 700]` also load the Bold file.
 */
export function buildFontFaceCss(font) {
    if (!font || !font.label) return ''

    const { name, folder } = fontFileBase(font)
    const weights = Array.isArray(font.weights)
        ? [...new Set(font.weights.map((w) => Number(w)).filter((w) => WEIGHT_FILE_SUFFIX[w]))].sort(
              (a, b) => a - b
          )
        : []

    if (weights.length === 0) {
        return faceRule(font.label, `${CDN_FONT_BASE}/${folder}/${name}-Regular.ttf`)
    }

    return weights
        .map((weight) =>
            faceRule(font.label, `${CDN_FONT_BASE}/${folder}/${name}-${WEIGHT_FILE_SUFFIX[weight]}.ttf`, {
                weight,
                style: 'normal'
            })
        )
        .join('\n')
}
